.mobile-menu-overlay {

    .menu-open &, .search-open &, &.login-open {
        position: fixed;
        z-index: $zindex-header - 1;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(#000, .20);
    }
}
